var React = require('react');

function PlayCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.0013 18.8332C14.6037 18.8332 18.3346 15.1022 18.3346 10.4998C18.3346 5.89746 14.6037 2.1665 10.0013 2.1665C5.39893 2.1665 1.66797 5.89746 1.66797 10.4998C1.66797 15.1022 5.39893 18.8332 10.0013 18.8332Z","stroke":"white","strokeWidth":"1.67","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8.33203 7.1665L13.332 10.4998L8.33203 13.8332V7.1665Z","stroke":"white","strokeWidth":"1.66667","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

PlayCircle.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = PlayCircle;

PlayCircle.default = PlayCircle;
